import { getOrderAppointmentList } from 'aster-foundation/core/teleconsultant/home/redux/actions';
import { getUpcomingOrders } from 'aster-foundation/core/homecare/cart/redux/actions';
import { capitalize } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { APP_LOCAL_DATETIME_FORMAT_SA2, DELIVERY_METHOD, SCREEN_NAME } from '@common/Utility/constants';
import { PRODUCT_CARD_DEFAULT, IC_HOME_CARE_APPOINTMENT, IC_FLASH_BOY } from '@common/Assets/images';
import { MIN_MOBILE_WIDTH, errorHandling, getDayLabel } from '@common/Utility/common-utils';
import { convert24to12HourFormat, convertUtcToGst,  convertDateMonthToCommaFormat } from '@common/Utility/date-utils';
import WithLoader from '../Loader/WithLoader';
import UpcomingCard from '../UpcommingCard/UpcomingCard';
import { AllUpcomingOrdersStyled } from './AllUpcomingOrdersStyled';

let countComma = 0;
const AllUpcomingOrders = (props) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.teleconsultant?.getOrderAppointmentList?.isFetching);
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource);
  const guestLogin = useSelector((state) => state?.astercore?.guestAccessToken?.data);
  const [isMobile, setIsMobile] = React.useState(false);
  const [upcomingDetailData, setUpcomingDetailData] = React.useState([]);

  const orderString = (arr) => {
    const temp = arr.join(', ');
    let temp1;
    if (isMobile) {
      temp1 = temp.substring(0, 14);
    } else {
      temp1 = temp.substring(0, 34);
    }
    countComma = temp1.split(',').length;
    if (countComma > 1 && temp.length > 26) {
      temp1 += '...';
    }
    return temp1;
  };

  const getTitle = (type, data) => {
    let title = '';
    if (type === 'Shipment') {
      title = data?.shipment;
    }
    if (type === 'Appointment') {
      title = data?.doctorName;
    }
    if (type === 'HOME') {
      title = orderString(data?.listOfProducts);
    }
    if (type === 'Prescription') {
      title = data?.type;
    }
    return title;
  };

  const getImage = (type, data) => {
    let img = PRODUCT_CARD_DEFAULT;
    if (type === 'Shipment') {
       if (data?.deliveryMethod === DELIVERY_METHOD.FLASH) {
         img = data?.deliveryMethodImage || IC_FLASH_BOY.src;
       } else {
         img = data?.deliveryMethodImage;
       }
    }
    if (type === 'Appointment') {
      img = data?.doctorProfileURLWeb;
    }
    if (type === 'HOME') {
      img = data?.imageIcon;
    }
    if (type === 'Prescription') {
      img = data?.deliveryMethodImage;
    }
    return img;
  };

  const getStatus = (type, data) => {
    const statusObject = {
      Shipment: data?.deliveryTitle,
      Appointment: data?.status,
      HOME: data?.status,
      Prescription: data?.deliveryTitle,
    };
    return statusObject[type];
  };

  const getDate = (type, data, method) => {
    const dateObject = {
      Shipment:
        method === 'Standard'
          ? `${`${data?.formattedDate}, ${data?.formattedTime}`}`
          : `Arriving ${getDayLabel(data?.deliveryDate,APP_LOCAL_DATETIME_FORMAT_SA2)} at ${data?.formattedTime}`,
      Appointment: convertDateMonthToCommaFormat(data?.date),
      HOME: convertDateMonthToCommaFormat(data?.date),
      Prescription: data?.rxOrder
      ? `Arriving ${getDayLabel(data?.deliveryDate, APP_LOCAL_DATETIME_FORMAT_SA2)} at ${data?.formattedTime}`
      : `${`${data?.formattedDate}, ${data?.formattedTime}`}`,
    };
    return dateObject[type];
  };

  const getSubTitle = (type, data) => {
    if (type === 'Shipment') {
      return orderString(data?.itemNames);
    }
    if (type === 'Appointment') {
      return data?.specialization;
    }
    if (type === 'Prescription') {
      return `${data?.count}  Document${data?.count > 1 ? 's' : ''}`;
    }
    return '';
  };

  const getMoreData = (type) => {
    const moreObject = {
      Shipment: 'items',
      HOME: 'more',
    };
    return moreObject[type];
  };

  const getId = (type, data) => {
    const moreObject = {
      Shipment: data?.runOrderId,
      HOME: data?.bookingId,
      Appointment: data?.id,
      Prescription: data?.id,
    };
    return moreObject[type];
  };

  const getMoreCount = (type, data) => {
    if (type === 'Shipment' || data?.rxOrder ) {
      return data.itemNames.length - countComma;
    }
    if (type === 'HOME') {
      return data.listOfProducts.length - countComma;
    }
    return 0;
  };

  const getConvertedTime = (isInstantGp, startTime) =>
    isInstantGp ? `${convert24to12HourFormat(startTime)}` : `${convertUtcToGst(startTime)}`;

  const serializeResponse = (response) => {
    const upcomingDetail = [];

    response?.forEach((appointment) => {
      const type = appointment?.type;
      const patientName = appointment?.userName;
      const status = getStatus(type, appointment);
      const appointmentTypeImage = appointment?.imageIcon;
      const cardImage = getImage(type, appointment);
      const id = getId(type, appointment);
      const rxOrder = appointment?.rxOrder;
      const erxId = appointment?.erxId;
      const title = getTitle(type, appointment);
      const subTitle = getSubTitle(type, appointment);
      const date = getDate(type, appointment, appointment?.deliveryMethod);
      let time = type === 'HOME' ? capitalize(appointment?.schedule) : convert24to12HourFormat(appointment?.date);
      time = type ==='Appointment' ? getConvertedTime(appointment?.instantGpAppointment, appointment?.date) : time;
      const isEstimated = true;
      const moreCount = getMoreCount(type, appointment);
      const moreData = getMoreData(type);
      const method = appointment?.deliveryMethod;
      const itemsList = appointment?.listOfProducts
        ? appointment?.listOfProducts?.join(',')
        : appointment?.itemNames?.join(',');
      const orderData = type === 'Shipment' && appointment?.orderDetails;

      upcomingDetail.push({
        type,
        patientName,
        status,
        subTitle,
        appointmentTypeImage,
        cardImage,
        id,
        date,
        title,
        isEstimated,
        moreCount,
        moreData,
        time,
        method,
        itemsList,
        orderData,
        rxOrder,
        erxId,
      });
    });
    setUpcomingDetailData(upcomingDetail);
  };

  const serializeResponseForHomcare = (response) => {
    const upcomingDetail = [];

    response?.forEach((appointment) => {
      const type = 'HOME';
      const patientName = appointment?.customerInfo?.name;
      const status = 'Confirmed';
      const cardImage = IC_HOME_CARE_APPOINTMENT.src;
      const id = appointment?.bookingId;
      const title = capitalize(appointment?.appointmentDetails?.bookedservices[0]?.serviceName?.toLowerCase());
      const date = moment.parseZone(appointment?.appointmentDetails?.serviceDateTime).local().format('DD MMM, YYYY');
      const time = capitalize(appointment?.appointmentDetails?.schedule.toLowerCase());
      const moreCount =
        appointment?.appointmentDetails?.bookedservices.length > 1
          ? Number(appointment?.appointmentDetails?.bookedservices.length) - 1
          : 0;
      const moreData = getMoreData(type);

      upcomingDetail.push({
        type,
        patientName,
        status,
        cardImage,
        id,
        date,
        title,
        moreCount,
        moreData,
        time,
      });
    });
    setUpcomingDetailData(upcomingDetail);
  };

  const allupcoming = () => {
    if (guestLogin || userLogin) {
      dispatch(
        getOrderAppointmentList({
          queryParam: {
            allProfiles: true,
            pageSize: 10,
          },
          onSuccess: (response) => {
            serializeResponse(response?.data);
          },
          onFailure: (err) => {
            errorHandling(err, true);
          },
        }),
      );
    }
  };

  const getUserLoginMemo = React.useMemo(() => userLogin?.id, [userLogin?.id]);

  const fetchUpcomingOrders = () => {
    if(userLogin){
      const params = {
        id: userLogin?.id,
        limit: 10,
        offset: 0,
        status: 'BOOKED'
      };
      dispatch(
        getUpcomingOrders({
          params,
          onSuccess: (result) => {
            serializeResponseForHomcare(result?.response?.data);
          },
          onFailure: (err) => {
            errorHandling(err);
          },
        }),
      );
    }
  };

  React.useEffect(() => {
    if (props?.screenName === SCREEN_NAME?.HC) {
      fetchUpcomingOrders();
    } else {
      allupcoming();
    }
  }, [getUserLoginMemo]);

  React.useEffect(() => {
    if (window.innerWidth <= MIN_MOBILE_WIDTH) {
      setIsMobile(true);
    } else if (window.innerWidth > MIN_MOBILE_WIDTH) {
      setIsMobile(false);
    }
  }, []);

  React.useEffect(() => {
    props.setLoading(loading);
  }, [loading]);

  return (
    <AllUpcomingOrdersStyled className={props?.outerClass}>
      <UpcomingCard data={upcomingDetailData} screenName={props?.screenName}/>
    </AllUpcomingOrdersStyled>
  );
};

AllUpcomingOrders.defaultProps= {
  outerClass: '',
  type: '',
  setLoading: ()=>{},
  screenName: '',
};

AllUpcomingOrders.propTypes = {
  outerClass: PropTypes.string,
  setLoading: PropTypes.func,
  type: PropTypes.string,
  screenName: PropTypes.string,
};

export default AllUpcomingOrders;